module.exports = __webpack_public_path__ + "img/1440.7caaf837.jpg";